import React, { useState, useEffect } from 'react';
import './CardLike.css';
import axios from 'axios';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useUser } from '../UserContext';

const CardLike = ({ cardid, contestid, initialLiked = false }) => {
    const [liked, setLiked] = useState(initialLiked);
    const [likers, setLikers] = useState([]);
    const [showLikers, setShowLikers] = useState(false);
    const { cards, setCards } = useUser();

    useEffect(() => {
        setLiked(initialLiked);
        fetchLikers();
    }, [cardid, initialLiked]);

    const fetchLikers = async () => {
        try {
            const response = await axios.get(`/api/contest/likers.php?card_id=${cardid}&contest_id=${contestid}`);
            setLikers(response.data);
        } catch (error) {
            console.error('Error fetching likers:', error);
        }
    };

    const handleClick = async () => {
        try {
            const response = await axios.post('/api/contest/like.php', { card_id: cardid, contest_id: contestid });
            const newLikedState = response.data.liked;
            setLiked(newLikedState);
            
            // Update the cards state in UserContext
            if (cards && setCards) {
                const updatedCards = cards.map(card => {
                    if (parseInt(card.id) === parseInt(cardid)) {
                        return { ...card, liked: newLikedState ? 1 : 0 };
                    }
                    return card;
                });
                setCards(updatedCards);
            }
            
            fetchLikers(); // Refresh the likers list
        } catch (error) {
            console.error('Error submitting like:', error);
        }
    };

    const renderTooltip = (props) => (
        <Tooltip id="liker-list-tooltip" {...props}>
            {likers.length > 0 ? (
                likers.map((liker, index) => (
                  <div key={index}>{liker.username}</div>
                ))
            ) : (
                <div>No likes yet.</div>
            )}
        </Tooltip>
    );

    return (
        <div className="card-like-container">
           <div className="card-like-inner d-flex align-items-center">
                <OverlayTrigger
                    placement="bottom"
                    show={showLikers}
                    overlay={renderTooltip}
                    onToggle={(show) => setShowLikers(show)}
                >
                  <Button
                      variant="outline-danger"
                        size="lg"
                        className={`like-button-bootstrap ${liked ? 'liked' : ''}`}
                        onClick={handleClick}
                    >
                        {liked ? '❤️' : '🤍'}
                    </Button>
                </OverlayTrigger>
                <span className="like-text ms-2">{liked ? 'Remove your Vote' : 'Vote for this Card'}</span>
             </div>
         </div>
    );
};

export default CardLike;